import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import * as actions from '../../actions'

class Mover extends Component {
  constructor (props) {
    super(props)

    this.state = {
      location: '',
      saving: false
    }

    this.onSubmit = this.onSubmit.bind(this)
  }

  componentDidMount () {
    this.setState({ location: this.props.location })
  }

  onSubmit (ev) {
    ev.preventDefault()
    if (this.state.location === this.props.location) {
      this.props.dispatch(actions.displayAlert('There is no change to save.'))
      return
    }
    this.props.dispatch(actions.changeTeamLocation({ id: this.props.id, location: this.state.location }))
    this.setState({ saving: true })
  }

  render () {
    return (
      <div className='change-status-container'>
        {this.state.saving && <div className='saving-msg'>Saving...</div>}
        <div className='cell-subject' style={{ width: '25%', backgroundColor: '#c53622', display: 'flex', justifyContent: 'center' }}>
          <Link to={`/team/${this.props.id}`} target='_blank' className='color-inherit'>
            {this.props.name}
          </Link>
        </div>
        <form className='status-form' onSubmit={this.onSubmit}>
          <input
            type='radio'
            name='status'
            value='Barcelona'
            className='radio-bttn'
            checked={this.state.location === 'Barcelona'}
            onChange={() => this.setState({ location: 'Barcelona' })} />
          <span className='bttn-info' onClick={() => this.setState({ location: 'Barcelona' })}>bcn</span>
          <input
            type='radio'
            name='status'
            value='Sofia'
            className='radio-bttn'
            checked={this.state.location === 'Sofia'}
            onChange={() => this.setState({ location: 'Sofia' })} />
          <span className='bttn-info' onClick={() => this.setState({ location: 'Sofia' })}>sof</span>
          <input
            type='radio'
            name='status'
            value='Madrid'
            className='radio-bttn'
            checked={this.state.location === 'Madrid'}
            onChange={() => this.setState({ location: 'Madrid' })} />
          <span className='bttn-info' onClick={() => this.setState({ location: 'Madrid' })}>mad</span>
          <input
            type='radio'
            name='status'
            value='Amsterdam'
            className='radio-bttn'
            checked={this.state.location === 'Amsterdam'}
            onChange={() => this.setState({ location: 'Amsterdam' })} />
          <span className='bttn-info' onClick={() => this.setState({ location: 'Amsterdam' })}>ams</span>
          <input
            type='radio'
            name='status'
            value='Herzogenaurach'
            className='radio-bttn'
            checked={this.state.location === 'Herzogenaurach'}
            onChange={() => this.setState({ location: 'Herzogenaurach' })} />
          <span className='bttn-info' onClick={() => this.setState({ location: 'Herzogenaurach' })}>hrz</span>
          <input type='submit' value='MOVE' className='save-bttn cursor-pointer button button-sm' />
          <input type='button' value='✕' className='button button-sm cancel-bttn cursor-pointer' onClick={() => this.props.close(this.props.id)} />
        </form>
      </div>
    )
  }
}

export default connect()(Mover)



// WEBPACK FOOTER //
// ./src/screens/administration/Mover.js